// src/components/Modes.js
import React from 'react';
import PropTypes from 'prop-types';
import './Modes.css';

const Modes = ({
  videoSrc = '/videos/modes_gestures.mp4', 
}) => {
  return (
    <div className="chunk-container"> 
      <div className="chunk-content">
        <h1 className="normal-title">Build custom Modes to suit your needs</h1>
        <div className="modes-section"> 
          <div className="modes-text">
            <p>
            Optimize every task by creating a specific mode for it. You can fill a mode with a wide variety of actions,
             such as keyboard or mouse inputs, or special built-in functions
            </p>
            <button className="learn-more-btn" onClick={() => (window.location.href = '/docs/modes')}>Learn More</button>
          </div>
          <div className="modes-video">
            <video autoPlay loop muted>
              <source src={videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

Modes.propTypes = {
  videoSrc: PropTypes.string,
};

export default Modes;
